/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.0.0
 */
import produce from 'immer';
import { Reducer } from 'redux';

import { CreateInquiryActionsType } from './createInquiryActions';
import {
    MODAL_INQUIRY_ATTACH_FILE,
    MODAL_INQUIRY_ATTACH_FILE_FAILED,
    MODAL_INQUIRY_ATTACH_FILE_SUCCESSFUL,
    MODAL_INQUIRY_CLOSE,
    MODAL_INQUIRY_CREATE,
    MODAL_INQUIRY_CREATE_FAILED,
    MODAL_INQUIRY_CREATE_SUCCESSFUL,
    MODAL_INQUIRY_DETACH_FILE,
    MODAL_INQUIRY_DETACH_FILE_FAILED,
    MODAL_INQUIRY_DETACH_FILE_SUCCESSFUL,
    MODAL_INQUIRY_LOAD_TOPIC,
    MODAL_INQUIRY_LOAD_TOPIC_FAILED,
    MODAL_INQUIRY_LOAD_TOPIC_LIST,
    MODAL_INQUIRY_LOAD_TOPIC_LIST_FAILED,
    MODAL_INQUIRY_LOAD_TOPIC_LIST_SUCCESSFUL,
    MODAL_INQUIRY_LOAD_TOPIC_SUCCESSFUL,
    MODAL_INQUIRY_LOAD_USER,
    MODAL_INQUIRY_LOAD_USER_FAILED,
    MODAL_INQUIRY_LOAD_USER_SUCCESSFUL,
} from './createInquiryConstants';
import { ICreateInquiryReducer } from './types/createInquiryTypes';


export const initialCreateInquiryState: ICreateInquiryReducer = {
    attachList: [],
    inquiryForm: {},
    isLoading: false,
    topicInfo: {
        customAttrs: [],
        dictionaries: [],
        hiddenForFixedService: false,
        id: '',
    },
    topicList: [],
    message: '',
    userInfo: {
        account: 0,
        clntId: '',
        email: '',
        emailCheckPattern: '',
        msisdn: '',
        name: '',
        phone: 0,
        standardId: 0,
        subsId: '',
    },
};

const createInquiryReducer: Reducer<ICreateInquiryReducer, CreateInquiryActionsType> =
    (state: ICreateInquiryReducer = initialCreateInquiryState, action: CreateInquiryActionsType) =>
        produce(state, draft => {
            switch (action.type) {
                // LOAD INQUIRY USER
                case MODAL_INQUIRY_LOAD_USER:
                    draft.isLoading = true;
                    draft.type = action.payload.type;
                    break;
                case MODAL_INQUIRY_LOAD_USER_SUCCESSFUL:
                    draft.userInfo = action.payload;
                    break;
                case MODAL_INQUIRY_LOAD_USER_FAILED:
                    draft.message = action.payload;
                    break;

                // LOAD TOPIC LIST
                case MODAL_INQUIRY_LOAD_TOPIC_LIST:
                    draft.isLoading = true;
                    break;
                case MODAL_INQUIRY_LOAD_TOPIC_LIST_SUCCESSFUL:
                    draft.isLoading = false;
                    draft.topicList = action.payload;
                    break;
                case MODAL_INQUIRY_LOAD_TOPIC_LIST_FAILED:
                    draft.isLoading = false;
                    draft.message = action.payload;
                    break;

                // LOAD TOPIC INFO
                case MODAL_INQUIRY_LOAD_TOPIC:
                    draft.attachList = [];
                    draft.isLoading = true;
                    break;
                case MODAL_INQUIRY_LOAD_TOPIC_SUCCESSFUL:
                    draft.isLoading = false;
                    draft.topicInfo = action.payload;
                    break;
                case MODAL_INQUIRY_LOAD_TOPIC_FAILED:
                    draft.isLoading = false;
                    draft.message = action.payload;
                    break;

                // CREATE INQUIRY
                case MODAL_INQUIRY_CREATE:
                    draft.isLoading = true;
                    break;
                case MODAL_INQUIRY_CREATE_SUCCESSFUL:
                case MODAL_INQUIRY_CREATE_FAILED:
                    draft.isLoading = false;
                    break;

                // CLOSE INQUIRY
                case MODAL_INQUIRY_CLOSE:
                    return initialCreateInquiryState;

                // INQUIRY ATTACH FILE
                case MODAL_INQUIRY_ATTACH_FILE:
                case MODAL_INQUIRY_ATTACH_FILE_FAILED:
                    break;
                case MODAL_INQUIRY_ATTACH_FILE_SUCCESSFUL:
                    draft.attachList = [...draft.attachList, action.payload];
                    break;

                // INQUIRY DETACH FILE
                case MODAL_INQUIRY_DETACH_FILE:
                case MODAL_INQUIRY_DETACH_FILE_FAILED:
                    break;
                case MODAL_INQUIRY_DETACH_FILE_SUCCESSFUL:
                    draft.attachList = action.payload;
                    break;

                default:
                    break;
            }
        });

export default createInquiryReducer;
